import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, input, OnInit } from '@angular/core';

import { Title } from '@angular/platform-browser';
import { CloudData } from 'angular-tag-cloud-module';
import { CustomBarChartComponent } from '../../shared/components/custom-bar-chart/custom-bar-chart.component';
import { LineChartComponent } from '../../shared/components/line-chart/line-chart.component';
import { PrintFilterDataComponent } from '../../shared/components/print-filter-data/print-filter-data.component';
import {
  MAX_CLOUD_WORDS,
  WordCloudComponent,
} from '../../shared/components/word-cloud/word-cloud.component';
import { WordTableComponent } from '../../shared/components/word-table/word-table.component';
import { ChartTypeColorsEnum } from '../../utils/enums/chart-colors.enum';
import { IEvolutionReport } from '../../utils/interfaces/evolution-report';
import { IRankingReport } from '../../utils/interfaces/ranking-report';
import { IReportFilter } from '../../utils/interfaces/report-filter';
import { ISummaryReport } from '../../utils/interfaces/summary-report';
import { PrintDocument } from '../print-document';

@Component({
  selector: 'app-print-management-diary',
  standalone: true,
  host: {
    '[class.embedded]': 'embedded()',
  },
  imports: [
    CommonModule,
    CustomBarChartComponent,
    LineChartComponent,
    WordCloudComponent,
    WordTableComponent,
    PrintFilterDataComponent,
  ],
  templateUrl:
    '../../main/report/report-data/management-diary/management-diary.component.html',
  styleUrls: [
    '../../main/report/report-data/management-diary/management-diary.component.scss',
    '../../main/report/report-data/summary/summary.component.scss',
    '../../main/report/report-data/wordcloud/wordcloud.component.scss',
  ],
  styles: [
    `
      :host.embedded {
        display: block;
        break-inside: auto;
        page-break-inside: auto;
      }

      :host.embedded app-print-filter-data {
        display: none;
      }

      :host.embedded .card {
        break-inside: auto;
        page-break-inside: auto;
      }

      :host.embedded .card:first-of-type,
      :host.embedded .chart,
      :host.embedded .count,
      :host.embedded .satisfacao,
      :host.embedded .card-header,
      :host.embedded .wordcloud,
      :host.embedded .word-table,
      :host.embedded app-line-chart,
      :host.embedded app-custom-bar-chart,
      :host.embedded app-word-cloud,
      :host.embedded app-word-table {
        display: block;
        break-inside: avoid;
        page-break-inside: avoid;
      }

      :host.embedded ::ng-deep app-custom-bar-chart .content-bar,
      :host.embedded ::ng-deep app-custom-bar-chart .img-description,
      :host.embedded ::ng-deep app-custom-bar-chart .values,
      :host.embedded ::ng-deep app-custom-bar-chart img {
        break-inside: avoid;
        page-break-inside: avoid;
      }

      :host.embedded .card > .title,
      :host.embedded .card > hr,
      :host.embedded .satisfacao,
      :host.embedded .count {
      
      // :host.embedded ::ng-deep app-custom-bar-chart .img-description,
      // :host.embedded ::ng-deep app-custom-bar-chart .values {
        break-after: avoid;
        page-break-after: avoid;
      }
    `,
  ],
})
export class PrintManagementDiaryComponent
  extends PrintDocument
  implements OnInit, AfterViewInit
{
  embedded = input(false);
  embeddedDataSummary = input<ISummaryReport | null>(null);
  embeddedDataEvolution = input<IEvolutionReport | null>(null);
  embeddedDataRanking = input<IRankingReport[] | null>(null);
  embeddedWordcloud = input<CloudData[] | null>(null);
  embeddedFilter = input<IReportFilter | null>(null);

  private readonly titleService = inject(Title);
  chartColorsEnum = ChartTypeColorsEnum;

  print = true;

  dataSummary!: ISummaryReport;
  dataEvolution!: IEvolutionReport;
  dataRanking: IRankingReport[] = [];
  wordcloud: CloudData[] = [];
  wordcloudChart: CloudData[] = [];
  filter: IReportFilter | null = null;
  countWordclound = 0;

  ngOnInit(): void {
    this.handleData();
  }

  ngAfterViewInit(): void {
    this.reportReadyData();
  }

  protected override handleData(): void {
    if (this.embedded()) {
      this.dataSummary = this.embeddedDataSummary() as ISummaryReport;
      this.dataEvolution = this.embeddedDataEvolution() as IEvolutionReport;
      this.filter = this.embeddedFilter();
      this.dataRanking = this.embeddedDataRanking() ?? [];
      this.wordcloud = this.embeddedWordcloud() ?? [];
      this.wordcloudChart = this.wordcloud.slice(0, MAX_CLOUD_WORDS);
      this.countWordclound = 0;

      this.wordcloud.forEach((data) => {
        this.countWordclound = this.countWordclound + data.weight;
      });

      return;
    }

    const { dataSummary, dataEvolution, filter, wordcloud, dataRanking } =
      this.activatedRoute.snapshot.data['data'];

    this.dataSummary = dataSummary;
    this.dataEvolution = dataEvolution;
    this.filter = filter;
    this.dataRanking = dataRanking;
    this.wordcloud = wordcloud ?? [];
    this.wordcloudChart = this.wordcloud.slice(0, MAX_CLOUD_WORDS);

    if (wordcloud) {
      this.wordcloud.forEach((data) => {
        this.countWordclound = this.countWordclound + data.weight;
      });
    }

    this.titleService.setTitle(
      this.changeTitlePage(
        'Relatório diário gerencial',
        filter.startDate,
        filter.finishDate
      )
    );
  }

  protected override reportReadyData(): void {
    if (this.embedded()) {
      return;
    }

    setTimeout(() => {
      this.printDocumentService.onDataReady();
    }, 3000);
  }
}
